import React, { useEffect, useState, useContext } from "react";
import { store } from '../../../../../context/StateProvider'
import NoteTemplateService from "../../../../../services/api/note-template.service";
import moment from "moment";
import ModalBox from "../../../../templates/components/ModalBox";
import NoteTemplateAdd from "../note-template-add/NoteTemplateAdd";
import NoteTemplateEdit from "../note-template-edit/NoteTemplateEdit";
import Table2 from "../../../../templates/components/Table2";
import APIResponse from "../../../../templates/components/APIResponse";
import DimLoader from "../../../../templates/components/DimLoader";
import PracticeLocationSelector from "../../../../templates/components/PracticeLocationSelector";

const NoteTemplateTable = (props) => {
    const globalStateAndDispatch = useContext(store)
    const state = globalStateAndDispatch.state
    const [isLoader, setIsLoader] = useState(false);
    const [showAdd, setShowAdd] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [noteTemplateList, setNoteTemplateList] = useState([]);
    const [selectedNoteTemplate, setSelectedNoteTemplate] = useState();
    const [apiResponse, setApiResponse] = useState()
    const [locationList, setLocationList] = useState(state.practiceLocations || null)
    const [locationId, setLocationId] = useState(state.practiceLocationId || null)
    const [initialMessage, setInitialMessage] = useState(true)
    //const [isLocationClearable, setIsLocationClearable] = useState(state.providerSelected?.practiceLocationUsers?.length > 0 ? false : true)
    const onSuccess = (message) => {
        findNoteTemplate();
        if (props.refresh) {
            props.refresh()
        }
        if (props.onClose) {
            props.onClose()
        }
        if (props.exitHandler) {
            props.exitHandler()
        }
    }

    const onLocationChanged = (newLocationId) => {
        setLocationId(newLocationId)
    }

    const findNoteTemplate = () => {
        let reqObj = { NotesType: 1 };
        if (locationId) {
            reqObj.PracticeLocationId = locationId
        }
        setIsLoader(true);
        setInitialMessage(false);
        NoteTemplateService.findNoteTemplate(reqObj)
            .then((response) => {
                if (response?.data?.data) {
                    setNoteTemplateList(response.data.data);
                } else {
                    setNoteTemplateList([]);
                }
                setIsLoader(false);
            })
            .catch((error) => {
                setNoteTemplateList([]);
                setIsLoader(false);
            });
    };

    const deleteHandler = () => {
        setDeleteModal(false);
        setIsLoader(true)
        NoteTemplateService.deleteNoteTemplate(selectedNoteTemplate.notesTemplateId)
            .then((response) => {
                setApiResponse(response);
            })
            .catch(error => {
                setApiResponse(error);
            })
            .finally(() => {
                setIsLoader(false)
            });
    };

    useEffect(() => {
        findNoteTemplate();
    }, [locationId])

    const columns = [
        {
            id: "createdOn",
            Header: "Created On",
            accessor: (template) => moment(template.createdOn).format("MM/DD/YYYY"),
        },
        {
            id: "shortCode",
            Header: "Short Code",
            accessor: item => item.shortCode,
        },
        {
            id: "notes",
            Header: "Notes",
            accessor: item => item.notes
        },
        {
            id: "practiceLocationId",
            Header: "Practice Location",
            accessor: item => item.practiceLocationId && Array.isArray(locationList) ? locationList.find(obj => obj.practiceLocationId === item.practiceLocationId)?.practiceLocation || null : 'Whole Practice'
        },
        {
            id: "actionNoteTemplate",
            Header: "Action",
            excludeFromExport: true, //to exclude from export
            disableSortBy: true,
            accessor: (template, i) => {
                return (
                    <div className="d-flex justify-content-start">
                        <button
                            className="p-0 ps-1 btn btn-primary"
                            title="Edit Note Template"
                            onClick={(e) => {
                                e.preventDefault();
                                setSelectedNoteTemplate(template);
                                return setOpenModal(true);
                            }}
                        >
                            <i className="icon pencil" />
                        </button>
                        <button
                            className="p-0 ps-1 btn btn-danger ms-1"
                            title="Delete Note Template"
                            onClick={(e) => {
                                e.preventDefault();
                                setSelectedNoteTemplate(template);
                                return setDeleteModal(true);
                            }}
                        >
                            <i className="icon trash" />
                        </button>
                    </div>
                );
            },
        },
    ];

    return (
        <>
            {isLoader &&
                <DimLoader loadMessage="Processing" />
            }
            <Table2
                export
                searchable
                loading={isLoader}
                columns={columns}
                data={noteTemplateList}
                initialMessage={initialMessage}
                extraButtons={[
                    {
                        className: 'btn btn-primary mt-auto',
                        children: <i className="icon plus" />,
                        title: "Add Note Template",
                        onClick: () => { setShowAdd(true) }
                    }
                ]}
                extraElements={
                    [
                        {
                            children:
                                <div className='col-md-auto'>
                                    <PracticeLocationSelector isClearable={true} dontResetState={true} onSelected={onLocationChanged} />
                                </div>
                        }
                    ]
                }
            />

            <ModalBox open={openModal} onClose={() => setOpenModal(false)} title="Edit Note Template">
                {selectedNoteTemplate && <NoteTemplateEdit
                    initialData={selectedNoteTemplate}
                    onClose={() => {
                        return setOpenModal(false);
                    }}
                    refresh={() => { findNoteTemplate() }}
                />}
            </ModalBox>

            <ModalBox
                open={deleteModal}
                onClose={() => setDeleteModal(false)}
                title="Confirm Delete"
                size="small"
                confirmButton="Delete"
                onCloseSuccess={deleteHandler}
            >
                <div className="row d-flex justify-content-between align-items-center">
                    <div className="col">
                        <p>Are you sure you want to delete the note template <strong>"{selectedNoteTemplate?.shortCode}"</strong>?</p>
                        <p>This action cannot be undone.</p>
                    </div>
                </div>
            </ModalBox>

            <ModalBox
                open={showAdd}
                onClose={() => {
                    setShowAdd(false);
                }}
                title="Add Note Template"
            >
                <NoteTemplateAdd
                    onClose={() => {
                        return setShowAdd(false);
                    }}
                    refresh={() => { findNoteTemplate() }}
                />
            </ModalBox>
            <APIResponse apiResponse={apiResponse} onSuccess={onSuccess} toastOnSuccess={true} successMessage="Note template deleted successfully" />
        </>
    );
};

export default NoteTemplateTable;
